var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isBackgroundImage
    ? _c(
        "picture",
        {
          attrs: {
            "data-iesrc": _vm.fallbackUrl || _vm.imageUrl,
            "data-picture-class": _vm.pictureClass,
            "data-alt": _vm.alt,
            "data-title": _vm.title
          }
        },
        [
          _vm._t("additionalimages"),
          _vm._v(" "),
          _vm.avifUrl
            ? _c("source", {
                attrs: { srcset: _vm.avifUrl, type: "image/avif" }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("source", {
            attrs: { srcset: _vm.imageUrl, type: _vm.mimeTypeOf(_vm.imageUrl) }
          }),
          _vm._v(" "),
          _vm.fallbackUrl
            ? _c("source", {
                attrs: {
                  srcset: _vm.fallbackUrl,
                  type: _vm.mimeTypeOf(_vm.fallbackUrl)
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("img", {
            class: _vm.pictureClass,
            attrs: {
              src: _vm.fallbackUrl || _vm.imageUrl,
              alt: _vm.alt,
              title: _vm.title,
              loading: _vm.loading,
              fetchpriority: _vm.fetchpriority
            }
          })
        ],
        2
      )
    : _c(
        "div",
        {
          class: _vm.pictureClass,
          attrs: { "data-background-image": _vm.backgroundSource }
        },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }